import React, {useState, useEffect} from 'react';
// import logo from '../../logo.svg';
import './App.css';
import Table from '../../Components/Table';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';

function App() {
  const [members, setMembers] = useState('');
  const [loading, setLoading] = useState(false);    

  const getData = () => {
    setLoading(true);
    fetch('https://getfit.btwb.com/tiggy/madness-production.json', {
      method: 'GET'
    }).then(res => {
      if(!res.ok) return;
      return res.json();
    }).then(response => {
      setLoading(false);
      setMembers(response.leaderboard)

    }).catch(err => {
      setLoading(false);
      console.log(err);
    })
  }

  useEffect(getData, [])

  return (
    <div className="App">
      <Header />
      {/*<div className="donate-banner w-100 pa3 white flex items-center">
        <div className="w-80 pa2 tl f6">
          This is a decription for Madness event leaderboard
        </div>
        <div className="w-20">
          <a className="no-underline db mr0" href="https://fundraise.barbellsforboobs.org/fundraiser/pursuing-health">
            <div className="header-button banner-button pa3 mb0 ml-auto mr0">Donate</div>
          </a>
        </div>
      </div>*/}
      <div className="donate-banner w-100 pa3 white flex items-center">
        <p className="f6 f5-ns mv0 w-80 tl">To participate: Just hashtag #madness in the notes of ONE workout post and you’re IN.</p> 
        <div className="w-20">
          <a className="no-underline db mr0" href="https://crossfitbtwb.com/signup">
            <div className="header-button banner-button pa3 mb0 ml-auto mr0">Sign up</div>
          </a>
        </div>
      </div>
      <div className="ph3 mt3 pt1 tl center f6 flex items-end justify-between flex-wrap flex-nowrap-ns">
        <div className="w-100 hack-width mb3">
  The Annual Madness is the brainchild of <a href="https://www.instagram.com/tosh.crookedbutterfly/">Tosh</a>. This year is all about the reps and each month will be a different rep-based challenge. 
  Just post all the work you do into btwb like normal and we’ll add up all your reps and points for you. Are you IN or OUT?
          <div className="workout">
            <p className="f6 fw6 mb0">December's Challenge</p>
            <p className="f6 mv0">Accumulate as many points as you can in the month.</p>
            <ul className="f6">
              <li>1 Ring Muscle-up = 5 points</li>
            </ul>
            {/*<p className="f6 mv0">Target: 2000pts.</p>*/}
          </div>
        </div>
        <div className="w-100 w-25-ns w-20-ns tr mt3">
           * Updated every 10 minutes <br/>
        </div>
      </div>
      <Table
        members={members}
      />
      {(members.length === 0 && !loading) &&
        <div className="mt2">
          <h2 className="tc">No workouts yet!</h2>
        </div>
      }
      <Footer />
    </div>
  );
}

export default App;